<template>
  <el-form-item :label="labelContent" :prop="prop" :rules="ruleObj">
    <el-select
      v-model="companyVal"
      v-bind="attrOption"
    >
      <el-option
        v-for="(item) in companyList"
        :key="item[valueOption.value]"
        :label="item[valueOption.label]"
        :value="item[valueOption.value]"
      ></el-option>
    </el-select>
  </el-form-item>
</template>
<script>
export default {
  name: 'CompanySelect',
  model: {
    prop: 'model',
    event: 'change',
  },
  props: {
    model: {
      type: [String, Number],
      default: '',
    },
    prop: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: true,
    },
    useType: {
      type: String,
      default: 'search', // search 搜索区域,unSearch 非搜索区域
    },
    label: {
      type: String,
      default: '所属公司',
    },
  },
  watch: {
    $attrs(n) {
      if (!this.sessionCompanyId) {
        this.$set(this.attrOption, 'disabled', n.disabled)
      }
    },
  },
  data() {
    return {
      valueOption: {
        label: 'companyName',
        value: 'companyId',
      },
      rules: [
        { required: true, message: '请选择所属公司', trigger: 'change' },
      ],
      attrOption: {},
    }
  },
  mounted() {
    this.attrOption = {
      filterable: true,
      clearable: true,
      placeholder: '请输入公司名称',
      disabled: false,
      ...this.$attrs,
    }
    // 公司下禁用
    const { sessionCompanyId, useType } = this
    if (sessionCompanyId) {
      this.companyVal = sessionCompanyId
      this.attrOption.disabled = true
    }
    // 搜索区域所属公司选项不禁用
    if (sessionCompanyId && useType === 'search') {
      this.attrOption.disabled = false
      this.attrOption.clearable = false
    }
  },
  computed: {
    // label 用作搜索不带冒号，页面表单加上冒号
    labelContent() {
      if (this.useType === 'search') {
        return this.label.replace(/[:：]/g, '')
      } else {
        return `${this.label.replace(/[:：]/g, '')}:`
      }
    },
    // 公司列表
    companyList() {
      return this.$store.getters.company
    },
    // 当前用户所在公司
    sessionCompanyId() {
      return this.$store.getters.userInfo.sessionCompanyId
    },
    // 获取选中公司数据
    companyVal: {
      set(newValue) {
        this.$emit('change', newValue)
      },
      get() {
        return this.model ? Number(this.model) : this.model
      },
    },
    // 校验规则
    ruleObj() {
    // 传入prop的话，需要进行必填校验
      return this.required ? this.rules : []
    },
  },
}

</script>
<style lang="scss" scoped></style>
